import type { Resource } from '../../';
export const cart_promotions_applied: Resource = {"default":"Promotion applied: {label} ({count})"};
